import { Link } from 'react-router-dom';
import ModernNavigation from '@/components/ModernNavigation';
import Footer from '@/components/Footer';
import { Card, CardContent } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Baby, Shield, Heart, ArrowRight } from 'lucide-react';

const VelosEnfants = () => {
  return (
    <div className="min-h-screen bg-background">
      <ModernNavigation />
      
      {/* Hero Section */}
      <section className="relative bg-gradient-to-br from-emerald-50 to-white py-20">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <div className="inline-flex items-center bg-emerald-100 text-emerald-700 px-4 py-2 rounded-full text-sm font-medium mb-4">
              <Baby className="w-4 h-4 mr-2" />
              Vélos enfants
            </div>
            <h1 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-4">
              Location de vélos enfants
            </h1>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              Des vélos adaptés et sécurisés pour que vos enfants profitent pleinement de leurs vacances à vélo
            </p>
          </div>

          {/* Features Grid */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-12">
            <Card className="border-0 shadow-lg text-center">
              <CardContent className="p-6">
                <Shield className="w-12 h-12 text-emerald-600 mx-auto mb-4" />
                <h3 className="font-bold text-gray-900 mb-2">Sécurité maximale</h3>
                <p className="text-sm text-gray-600">Freins adaptés, stabilisateurs disponibles</p>
              </CardContent>
            </Card>

            <Card className="border-0 shadow-lg text-center">
              <CardContent className="p-6">
                <Heart className="w-12 h-12 text-emerald-600 mx-auto mb-4" />
                <h3 className="font-bold text-gray-900 mb-2">Toutes les tailles</h3>
                <p className="text-sm text-gray-600">De 12 à 24 pouces selon l'âge</p>
              </CardContent>
            </Card>

            <Card className="border-0 shadow-lg text-center">
              <CardContent className="p-6">
                <Baby className="w-12 h-12 text-emerald-600 mx-auto mb-4" />
                <h3 className="font-bold text-gray-900 mb-2">Accessoires inclus</h3>
                <p className="text-sm text-gray-600">Casque, sonnette, panier</p>
              </CardContent>
            </Card>
          </div>

          {/* Description */}
          <div className="bg-white rounded-xl shadow-lg p-8 mb-12">
            <h2 className="text-2xl font-bold text-gray-900 mb-6">
              Nos vélos pour enfants
            </h2>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
              <div>
                <h3 className="font-semibold text-gray-900 mb-3">Vélos 12-16 pouces (2-5 ans)</h3>
                <ul className="space-y-2 text-gray-700">
                  <li>• Stabilisateurs amovibles</li>
                  <li>• Freins adaptés aux petites mains</li>
                  <li>• Selle et guidon réglables</li>
                  <li>• Panier avant inclus</li>
                  <li>• Casque fourni</li>
                </ul>
              </div>
              <div>
                <h3 className="font-semibold text-gray-900 mb-3">Vélos 20-24 pouces (6-12 ans)</h3>
                <ul className="space-y-2 text-gray-700">
                  <li>• Vitesses pour les plus grands</li>
                  <li>• Freins V-brake efficaces</li>
                  <li>• Béquille latérale</li>
                  <li>• Porte-bagages arrière</li>
                  <li>• Casque fourni</li>
                </ul>
              </div>
            </div>

            <div className="mt-8 p-6 bg-emerald-50 rounded-lg">
              <h3 className="font-semibold text-gray-900 mb-2">Équipements complémentaires</h3>
              <p className="text-gray-700 mb-4">
                Pour les plus petits, nous proposons également :
              </p>
              <ul className="space-y-2 text-gray-700">
                <li>• Sièges bébé (jusqu'à 22 kg)</li>
                <li>• Remorques vélo (1 ou 2 places)</li>
                <li>• Barres de traction (follow-me)</li>
                <li>• Draisiennes pour les tout-petits</li>
              </ul>
            </div>
          </div>

          {/* CTA Section */}
          <div className="text-center">
            <Link to="/reserver">
              <Button className="bg-emerald-600 hover:bg-emerald-700 text-white font-semibold px-8 py-3 text-lg rounded-lg shadow-lg hover:shadow-xl transition-all">
                <Baby className="w-5 h-5 mr-2" />
                Réserver un vélo enfant
                <ArrowRight className="w-5 h-5 ml-2" />
              </Button>
            </Link>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default VelosEnfants;